import { Device } from "./Device"
import { ComponentDefinition, ComponentIdentifier } from "../../render/componentLoader"
import { runtime } from "../../utils/runtimeInjection"

/**
 * @internal
 */
export type DevicesData = {
    devices: { [key: string]: ComponentDefinition }
    deviceSkins: { [key: string]: ComponentDefinition }
}

/**
 * @internal
 */
export class DeviceRegistry {
    resolve(identifier: string): typeof Device | undefined {
        const component = runtime.componentLoader.componentForIdentifier(identifier)
        if (!component || component.type !== "device") {
            return undefined
        }
        return component.class as typeof Device
    }

    list(): DevicesData {
        const devices = {}
        const deviceSkins = {}
        const componentIdentifiers = runtime.componentLoader.componentIdentifiers()
        componentIdentifiers.map((identifier: ComponentIdentifier) => {
            const component = runtime.componentLoader.componentForIdentifier(identifier)
            if (component && component.type === "device") {
                devices[component.identifier] = (component.class as typeof Device).descriptor
                if (component) {
                    if (component.type === "device") {
                        devices[component.identifier] = (component.class as typeof Device).descriptor
                    } else if (component.type === "device-skin") {
                        deviceSkins[component.identifier] = (component.class as typeof Device).descriptor
                    }
                }
            }
        })
        return { devices, deviceSkins }
    }
}
